import React from 'react';

import { Loader as Spinner } from '@eika/loader';

interface Props {
    title?: string;
}

const Loader = ({ title = '' }: Props): JSX.Element => (
    <div className="loader">
        <div style={{ maxWidth: '500px', margin: '0 auto' }}>
            <>
                <Spinner ariaLabel={title} className="loader__spinner" />
                <br />
                <div className="loader__title text-center">{title}</div>
            </>
        </div>
    </div>
);

export default Loader;
